import EDC from '../../../../components/games/shared/globals';
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Preloader = function () {};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Preloader.prototype.create = function () {
  this.load.setPath('../phaser-assets/images/views/intro/');

  this.load.on('complete', this.onLoadImagesComplete, this);
  // this.load.image("logo",    "logo.png");
  this.load.svg('logo', 'logo.svg', { width: 680, height: 680 });
  this.load.image('border', 'border.png');
  this.load.image('letter0', 'Letters_1.png');
  this.load.image('letter1', 'Letters_2.png');
  this.load.image('letter2', 'Letters_3.png');

  this.load.setPath();
  this.load.start();
};
/**
 *
 */
EDC.Games.TitleIntro.Scenes.Preloader.prototype.onLoadImagesComplete = function () {
  this.load.off(this.onLoadImagesComplete, this);
  this.scene.start('TitleIntro-Main');
};

export default EDC.Games.TitleIntro.Scenes.Preloader;
